import React, { useEffect } from "react";
import { Spinner } from "react-bootstrap";

import type { IBillingInfo } from "../../../hooks/reactQueryHooks/useBilling";
import { useCheckoutLink } from "../../../hooks/reactQueryHooks/useBilling";

interface ChargeNotificationProps {
  organization: string;
  isOwner: boolean;
  data: IBillingInfo;
}

const ChargeNotification: React.FC<ChargeNotificationProps> = ({
  organization,
  isOwner,
  data,
}) => {
  const settings = data?.ptuBillingInfo?.billingSettings;

  const {
    data: checkoutLink,
    isFetching,
    isLoading,
    refetch,
  } = useCheckoutLink(organization, window.location.href);

  const handleChargeClick = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    refetch();
  };

  const accountBallance =
    data?.ptuBillingInfo?.credits || data.ptuBillingInfo?.amountDue || 0;

  useEffect(() => {
    if (checkoutLink) {
      window.location.href = checkoutLink.url;
    }
  }, [checkoutLink]);

  const renderLink = () =>
    isOwner ? (
      <a
        href="/"
        className="permanent-notification__link"
        onClick={handleChargeClick}
      >
        Recharge
      </a>
    ) : (
      "Notify organization owner"
    );

  return settings &&
    accountBallance < settings.lowCreditBalanceThreshold &&
    data?.provider === "stripe" ? (
    <div className="permanent-notification">
      {accountBallance <= 0 ? (
        <span data-testid="out-of-credits">
          You’re out of credits.&nbsp;{renderLink()}&nbsp;now to restore API
          functionality.
        </span>
      ) : (
        <span data-testid="low-ballance">
          Your credit balance is running low.&nbsp;{renderLink()}&nbsp;now to
          avoid failed API requests.
        </span>
      )}

      {(isLoading || isFetching) && (
        <>
          &nbsp;
          <Spinner
            className="ms-2"
            size="sm"
            animation="border"
            data-testid="subscription-info-spinner"
          />
        </>
      )}
    </div>
  ) : null;
};

export { ChargeNotification };
